import { render, staticRenderFns } from "./DashboardWidget1.vue?vue&type=template&id=f39352ee&scoped=true"
import script from "./DashboardWidget1.vue?vue&type=script&lang=js"
export * from "./DashboardWidget1.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget1.vue?vue&type=style&index=0&id=f39352ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39352ee",
  null
  
)

export default component.exports